import { features } from "../Base/features.js";
import { isDefined } from "../utils/index.js";
function createApp(App, rootElement = document.body) {
  let app;
  const options = rootElement instanceof HTMLElement ? { root: rootElement, features: void 0 } : { root: document.body, ...rootElement };
  if (isDefined(options.features)) {
    for (const [feature, value] of Object.entries(options.features)) {
      features.set(feature, value);
    }
  }
  function init() {
    app = new App(options.root).$mount();
    return app;
  }
  let p;
  if (features.get("asyncChildren")) {
    p = Promise.resolve(init());
  } else {
    p = new Promise((resolve) => {
      if (document.readyState === "complete") {
        resolve(init());
      } else {
        document.addEventListener("readystatechange", () => {
          if (document.readyState === "complete") {
            resolve(init());
          }
        });
      }
    });
  }
  return () => p;
}
export {
  createApp as default
};
//# sourceMappingURL=createApp.js.map
